<template>
    <div uk-slideshow="autoplay: true; ratio: 16:9">

        <div class="uk-position-relative uk-visible-toggle _uk-light" tabindex="-1">
            <ul class="uk-slideshow-items">
                <li v-for="p in photos" :key="p.id">
                    <img :src="p.src" :data-id="p.id" :data-date="p.date"  uk-cover>
                    <div class="uk-overlay uk-overlay-default uk-position-bottom">
                        <p>{{ p.date }}</p>
                        <span class="tag uk-label uk-label-success uk-margin-small-right tag-label" v-for="tag in p.tags" v-bind:key="tag" @click="tagClick('tag', tag)">{{ tag }}</span>
                        <span class="area uk-label uk-label-primary uk-margin-small-right tag-label" v-for="area in p.areas" v-bind:key="area" @click="tagClick('area', area)">{{ area }}</span>
                        <span class="member uk-label uk-label-warning uk-margin-small-right tag-label" v-for="member in p.members" v-bind:key="member" @click="tagClick('member', member)">{{ member }}</span>
                    </div>
                </li>
            </ul>

            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>

        </div>

        <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-margin"></ul>

    </div>
</template>

<script>
/* eslint-disable */

export default {
    name: 'carousel',
    props: {

    },
    data () {
        return {
            photos: [],
        }
    },
    mounted () {
        this.$axios.post(
            this.$config.common.apiPath + '/getCarouselPhotos/'
        )
        .then(response => {
            // this.photos = response.data
            let photos = response.data.data
            photos.forEach(element => {
                var _obj = {}
                _obj.id = element.id
                _obj.date = element.date
                _obj.areas = element.areas
                _obj.members = element.members
                _obj.tags = element.tags
                _obj.src = this.$config.common.photoPath + element.photo
                this.photos.push(_obj)
            })
        })
        .catch( function(error){

        })
    }
}
</script>

<style>
.area {
    background-color: #FFE4A8;
    color: #444;
    border: 1px solid transparent;
}
.member {
    background-color: #412554;
    color: #fff;
    border: 1px solid transparent;
}
.tag {
    background-color: #008B52;
    color: #fff;
    border: 1px solid transparent;
}
</style>